exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1O50myzk49xycf0sTeY5B5{width:100%;font-size:12px}html[dir] ._1O50myzk49xycf0sTeY5B5{margin-top:20px;text-align:center}._1bkWP4cABn5opG1TDfbrb8{width:100%;font-size:12px}html[dir] ._1bkWP4cABn5opG1TDfbrb8{margin-top:8px}html[dir=ltr] ._1bkWP4cABn5opG1TDfbrb8{text-align:right}html[dir=rtl] ._1bkWP4cABn5opG1TDfbrb8{text-align:left}", ""]);
// Exports
exports.locals = {
	"systemMessage": "_1O50myzk49xycf0sTeY5B5",
	"errorMessage": "_1bkWP4cABn5opG1TDfbrb8"
};